import { httpByCurrentCustomer } from "@/lib/client";

export type DataListenedCalls = {
  listenTime: string;
  phone: string;
  duration: number;
  tags: Array<string>;
  callTime: string;
  organization: string;
  campaign: string;
  user: string;
};

export function getListenedCalls(
  date: string,
  format?: string
): Promise<DataListenedCalls[] | Blob> {
  if (format) {
    return httpByCurrentCustomer()
      .get(`callslistened/${date}?format=${format}`)
      .blob();
  } else {
    return httpByCurrentCustomer().get(`callslistened/${date}`).json();
  }
}
